import React from "react";
const PartnersSection = () => {
  return (
    <div className="flex flex-col items-center justify-center w-full py-8">
      <p className="text-lg text-center font-semibold mb-6">
      Our investors include the founders of
      </p>
      <div className="flex justify-center items-center gap-10 flex-wrap px-4">
        <a href="https://thirdhousecapital.com/" target="_blank" rel="noreferrer">
          <img
            src="/images/thirdhouse.png"
            alt="Casper"
            className="h-24"
          />
        </a>

        <a href="https://shousugibanhouse.com/" target="_blank" rel="noreferrer">
          <img
            src="/images/shou-sugi.jpg"
            alt="Casper"
            className="h-24"
          />
        </a>
      </div>
    </div>
  );
};

export default PartnersSection;
